export default __webpack_public_path__ + "static/media/female-active.713e0e40.png";